import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import { onMounted, ref } from 'vue';
import useCategoryBanner, {
  type Color,
  type AccentColor,
} from '@/composables/useCategoryBanner';
import { CdnImg } from '@webplatform/cdn-image';

export interface CategoryBannerData {
  image: string;
  title: string;
  color: Color;
  accentColor?: AccentColor;
  description?: string;
  modelsCount?: number;
  position?: number;
  link?: {
    src: string;
  };
}

interface Props {
  data: CategoryBannerData;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'CategoryBannerSmall',
  props: {
    data: { default: () => ({
    title: 'Banner title',
    description: 'Banner description',
    color: 'gray',
    image: '/img/watches.png',
    position: 1,
    modelsCount: 9,
  }) }
  },
  setup(__props: any) {

const props = __props as { data: CategoryBannerData };



const { buttonColor } = useCategoryBanner({
  color: props.data.color,
  accentColor: props.data.accentColor,
});

const banner = ref(null);

const { $gsap } = useContext();

const animateOnScroll = () => {
  const space = 50;
  const content = banner.value;
  const lines = (content as any).querySelectorAll('.line');
  lines.forEach((line: any) => {
    $gsap.fromTo(
      line,
      {
        x: -200,
        ease: 'none',
      },
      {
        x: 200,
        opacity: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: content,
          scrub: true,
          start: 'top bottom',
          end: 'bottom top',
          toggleActions: 'restart none none reverse',
        },
      },
    );
  });

  const boxes = (content as any).querySelectorAll('.box');
  boxes.forEach((box: any) => {
    $gsap.fromTo(
      box,
      {
        x: space,
        opacity: 0,
      },
      {
        x: 0,
        opacity: 1,
        ease: 'power1.in',
        scrollTrigger: {
          trigger: content,
          // scrub: true,
          start: 'top-=50% center',
          end: '25% center',
          toggleActions: 'restart none none reverse',
        },
      },
    );

    $gsap.fromTo(
      box,
      {
        x: 0,
        opacity: 1,
      },
      {
        x: space,
        opacity: 0,
        ease: 'power1.in',
        scrollTrigger: {
          trigger: content,
          // scrub: true,
          start: 'bottom center',
          end: 'center top',
          toggleActions: 'restart none none reverse',
        },
      },
    );
  });

  $gsap.fromTo(
    (content as any).querySelector('.image'),
    {
      x: space,
      opacity: 0,
    },
    {
      x: 0,
      opacity: 1,
      ease: 'power2.out',
      scrollTrigger: {
        trigger: content,
        // scrub: true,
        start: 'top-=50% center',
        end: '25% center',
        toggleActions: 'restart none none reverse',
      },
    },
  );
};

onMounted(() => {
  animateOnScroll();
});

return { __sfc: true,props, buttonColor, banner, $gsap, animateOnScroll, CdnImg }
}

})